import { createAsyncThunk } from "@reduxjs/toolkit";
import { Api } from "../..";
import { IGetFileAClaimFormFieldsJsonResponse } from "../../models/user/claims/claims";
import { CustomAction } from "../../store/customAction";
import {
  API_EDIT_ADD_TASK,
  API_GET_ADD_TASK_FORM_SCHEMA,
  API_POST_ADD_TASK,
} from "../../Apis/ApiEndPoints";
import {
  IEditAddTaskRequestParams,
  IPostAddTaskRequestParams,
} from "../../models/agent/Tasks/addTask";

export const getAddTaskFormFieldsJson = createAsyncThunk(
  "tasks/getAddTaskFormFieldsJson",
  async (_, { dispatch }) => {
    const response = await CustomAction(
      Api.get(API_GET_ADD_TASK_FORM_SCHEMA),
      dispatch,
      "tasks/getAddTaskFormFieldsJson"
    );
    return response;
  }
);

export const PostAddTask = createAsyncThunk(
  "tasks/PostAddTask",
  async (requestParams: IPostAddTaskRequestParams, { dispatch }) => {
    const response = await CustomAction(
      Api.post(API_POST_ADD_TASK, requestParams),
      dispatch,
      "tasks/PostAddTask"
    );
    return response;
  }
);
export const EditAddTask = createAsyncThunk(
  "tasks/EditAddTask",
  async (requestParams: IEditAddTaskRequestParams, { dispatch }) => {
    const response = await CustomAction(
      Api.put(API_EDIT_ADD_TASK, requestParams),
      dispatch,
      "tasks/EditAddTask"
    );
    return response;
  }
);
